import { AxiosResponse } from "axios";
import { API_URL } from "../constants/url-config";
import { LoginReq } from "../models/auth/sign-in";
import { getAsync, postAsync } from "../utils/http-client";
import cookie from "react-cookies";
import { CookieConstants, LOCAL_STORAGE_KEY } from "../constants/local";
import moment from "moment";
import { UserModel } from "../models/user.model";
import { RegisterModel } from "../models/auth/sign-up";


const authServiceUrl = API_URL.authService

const API_PATH = {
  signIn: "/get_token",
  useInfo: "/user_info",
  register: "/register_user",
  forgotPassword: "/forgot_password",
  resetPassword: "/reset_password"
}

const loginAsync = async (model: LoginReq): Promise<AxiosResponse> => {
  var url = API_PATH.signIn;

  return await postAsync(authServiceUrl, url, model, undefined, undefined, false, true, "text")
}

const getUserInfoAsync = async (): Promise<AxiosResponse> => {
  var url = API_PATH.useInfo;

  return await getAsync(authServiceUrl, url);
}

const register = async (model: RegisterModel): Promise<AxiosResponse> => {
  return await postAsync(authServiceUrl, API_PATH.register, model);
}

const forgotPassword = async (email: string): Promise<AxiosResponse> => {
  return await postAsync(authServiceUrl, API_PATH.forgotPassword, { email });
}

const resetPassword = async (token: string, password: string): Promise<AxiosResponse> => {
  return await postAsync(authServiceUrl, API_PATH.resetPassword, { token, password });
}

const logout = () => {
  Object.keys(cookie.loadAll()).forEach((item) => {
    cookie.remove(item, { path: "/" });
  });
  localStorage.clear();
  sessionStorage.clear();
}

const setLoginData = (data: { access_token: string; refresh_token: string }) => {
  //store some response data to cookie
  const tokenExpire = localStorage.getItem(LOCAL_STORAGE_KEY.REMEMBER_ME) === "true" ? 7 : 1;
  const expire = moment().add(tokenExpire, "d").toDate();
  cookie.save(CookieConstants.ACCESS_TOKEN, data.access_token, { expires: expire, path: "/" });
  if (data.refresh_token) {
    cookie.save(CookieConstants.REFRESH_TOKEN, data.refresh_token, { expires: expire, path: "/" });
  }

  cookie.save(CookieConstants.IS_LOGGED_IN, "true", { expires: expire, path: "/" });
}

const isLoggedIn = () => {
  return !!cookie.load(CookieConstants.IS_LOGGED_IN);
}

const setUserInfo = (user: UserModel) => {
  const tokenExpire = localStorage.getItem(LOCAL_STORAGE_KEY.REMEMBER_ME) === "true" ? 7 : 1;
  const expire = moment().add(tokenExpire, "d").toDate();
  cookie.save(CookieConstants.USER_INFO, user, { expires: expire, path: "/" });
  cookie.save(CookieConstants.PERMISSIONS, user.roles, { expires: expire, path: "/" })
}

const getUserInfo = () => {
  return cookie.load(CookieConstants.USER_INFO) as UserModel;
}

export const AuthService = {
  loginAsync,
  logout,
  isLoggedIn,
  setLoginData,
  getUserInfoAsync,
  setUserInfo,
  getUserInfo,
  register,
  forgotPassword,
  resetPassword
};
